import {useEffect, useState} from "react";
import {useQuery} from "@tanstack/react-query";
import {getManagedAuthorities} from "../services/AccountService";
import {useCurrentUser} from "./useCurrentUser";

export function useManagedRepTypes(userId, enabled = true, resetKey, callback = () => {
}) {

    const [repTypes, setRepTypes] = useState([]);

    // use useQuery to fetch business unit data
    const {data} = useQuery({
        queryKey: ['repTypes', userId, resetKey],
        queryFn: () => getManagedAuthorities(userId),
        enabled: !!userId && enabled,
    })

    useEffect(() => {
        if (data) {
            setRepTypes(data);
            callback(data);
        }
    }, [data]);

    return repTypes;
}